<template>
 <div class="modal" :class="{'is-active':isActive}" v-lazy-container="{ selector: 'img' }">
 	<div class="modal-background bg-black opacity-50"></div>
 	<div class="modal-card  w-10/12 md:w-1/2 rounded-md" :class="{'bg-white' : (dailyOffer.title && dailyOffer.body)}">
 		<div class="modal-header bg-secondary-300 flex justify-between" v-if="dailyOffer.title && dailyOffer.body">
 			<p class="text-white text-sm md:text-lg">{{dailyOffer.title}}</p>
 			<button class="text-white focus:outline-none" aria-label="close" @click="closeModal">
 				<i class="fas fa-times-circle"></i>
 			</button>
 		</div>
 		<div v-else>
 			<button class="absolute text-xl top-2 right-2 text-white focus:outline-none" aria-label="close" @click="closeModal">
 				<i class="fas fa-times-circle"></i>
 			</button>
 		</div>
 		<div class="modal-body scrollbar-thumb-gray-500 scrollbar-track-gray-300 hover:scrollbar-thumb-gray-600 scrollbar-sm" v-if="dailyOffer.title && dailyOffer.body">
 			<p class="text-center text-secondary-300 font-semibold text-xs md:text-base">{{dailyOffer.body}}</p>
 			<img class="max-h-140 w-full object-contain mt-3" :data-src="dailyOffer.image"> 			
 		</div>
 		<div v-else>
 			<img class="max-h-140 w-full object-contain mt-3" :data-src="dailyOffer.image">
 		</div>
 	</div>
 </div>
</template>
<script>
	export default {
		name:'OfferModal',
		props: {
			dailyOffer:{
				type: Object,
				required: true
			}
		},
		data() {
			return {
				isActive:false,
			};
		},
		created(){
			let da = this;
			document.addEventListener("DOMContentLoaded", (event) => {
				setTimeout(function(){ 					
					da.isActive = true;
				}, 4000);
			});
			
		},
		methods:{
			closeModal(){
				this.isActive= false;
			}
			
		},
		watch: {
			
		}


	};
</script>


// WEBPACK FOOTER //
// resources/assets/js/front/components/SiteComponents/Offers/OfferModal.vue